export default __webpack_public_path__ + "static/media/logo_dark.7ff371c6.svg";